// This entity has been generated, do not change its content, your changes might get lost. You CAN modify the rest of the file.
enum ChargeValidity {
  Days10 = "DAYS10",
  Days30 = "DAYS30",
  Annual = "ANNUAL",
  SingleDay = "SINGLE_DAY",
  Hours24 = "HOURS24",
}
export default ChargeValidity;
